import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IsControlInvalidAndTouchedPipe } from './is-control-invalid-and-touched.pipe';
import { IsControlRequiredPipe } from './is-control-required.pipe';
import { IsOptionSelected } from './is-option-selected.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    IsControlRequiredPipe,
    IsControlInvalidAndTouchedPipe,
    IsOptionSelected
  ],
  exports: [
    IsControlRequiredPipe,
    IsControlInvalidAndTouchedPipe,
    IsOptionSelected
  ],
})

export class SharedFormPipesModule {}
